import { Box } from "@mui/system";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RouteParamsProvider } from "../context/RouteParamsProvider";

import styles from "./app.module.scss";

import { WrapperUI } from "../components/WrapperUI";

export function App() {
  return (
    <Box className={styles.app}>
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <RouteParamsProvider>
                <WrapperUI />
              </RouteParamsProvider>
            }
          />
          <Route
            path="/:projectName"
            element={
              <RouteParamsProvider>
                <WrapperUI />
              </RouteParamsProvider>
            }
          />
        </Routes>
      </Router>
    </Box>
  );
}

export default App;
